import { useArtSpecs } from "./Context";
import styles from "./App.module.scss";

// use an image for the rest of the leadspace so we don’t have to deal with fonts and styles
import _320 from "../static/overlays/320.png";
import _672 from "../static/overlays/672.png";
import _1056 from "../static/overlays/1056.png";
import _1312 from "../static/overlays/1312.png";
import _1584 from "../static/overlays/1584.png";
const images = { 320: _320, 672: _672, 1056: _1056, 1312: _1312, 1584: _1584 };

export function Leadspace({ children }) {
  const { bp, width, setWidth, height } = useArtSpecs();
  const top = width < 672 ? 360 : width < 1056 ? 336 : 0;
  return (
    <div>
      <div className={styles.sectionLabel}>Preview</div>

      <div className={styles.viewport}>
        <input
          type="range"
          min="320"
          max="1700"
          value={width}
          id="myRange"
          aria-label="Screen width"
          className={styles.viewportSlider}
          onChange={(e) => setWidth(e.target.value)}
        />
        <div className={styles.readout}>
          <span>
            <span className={styles.readoutTerm}>Screen width </span>
            <span className={styles.readoutValue}>{width}px</span>
          </span>
          <span>
            <span className={styles.readoutTerm}>Leadspace component </span>
            <span className={styles.readoutValue}>
              {width}px × {height + top}px
            </span>
          </span>
          <span>
            <span className={styles.readoutTerm}>Art </span>
            <span className={styles.readoutValue}>
              {width}px × {height}px
            </span>
          </span>
        </div>
      </div>

      <div className={styles.canvasWrap}>
        <div style={{ width: width + "px", height: top + height, position: "relative" }}>
          <div style={{ position: "absolute", top, left: 0, width: "100%", height: height + "px" }}>{children}</div>
          <img src={images[bp]} alt="" style={{ position: "absolute", top: 0, left: 0 }} />
        </div>
      </div>
    </div>
  );
}
